import { render } from "./WizardDocumentacion.vue?vue&type=template&id=5aba43c0&scoped=true"
import script from "./WizardDocumentacion.vue?vue&type=script&lang=js"
export * from "./WizardDocumentacion.vue?vue&type=script&lang=js"

import "./WizardDocumentacion.vue?vue&type=style&index=0&id=5aba43c0&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aba43c0"]])

export default __exports__